// BS3-002: duplicate a 1:1 or SIL house shift to another date (staff never copied). Pure helpers, tested.

/** Can this user duplicate this shift? { can, reason } — the reason shows on the disabled button. */
export function canDuplicateShift(shift, permissions = []) {
  if (!shift) return { can: false, reason: '' };
  if (!permissions.includes('roster.create')) return { can: false, reason: 'You need roster create permission' };
  if (shift.session_id || shift.centre_session_id || String(shift.support_type || '').toLowerCase() === 'group') {
    return { can: false, reason: 'Centre session and group shifts are copied from their own screens' };
  }
  const sil = !!(shift.house_id || shift.linked_house_id) || String(shift.support_type || '').toLowerCase() === 'sil';
  if (sil && String(shift.support_ratio || '').trim() === '2:1') {
    return { can: false, reason: 'A 2:1 SIL shift needs both workers when created — create it from the house view' };
  }
  if (!sil && !shift.participant_id && !(shift.linked_participants || []).length) return { can: false, reason: 'This shift has no participant to copy' };
  return { can: true, reason: '' };
}

/** ISO date + n days (TZ-safe). */
export function addDays(iso, n) {
  const [y, m, d] = String(iso || '').slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '';
  const t = new Date(Date.UTC(y, m - 1, d + n));
  return t.toISOString().slice(0, 10);
}

/** Body for POST /roster/shifts/{id}/duplicate — times only when changed; null + message when invalid. */
export function duplicatePayload(shift, form) {
  if (!form.date) return { error: 'Choose the date to copy the shift to' };
  if (!form.start_time || !form.end_time) return { error: 'Enter the start and end time' };
  if (form.start_time === form.end_time) return { error: 'Start and end time cannot be the same' };
  if (form.date === shift.date && form.start_time === shift.start_time && form.end_time === shift.end_time) {
    return { error: 'Choose another date or time — the copy would sit on top of the original shift' };
  }
  const body = { shift_date: form.date };
  if (form.start_time !== shift.start_time) body.start_time = form.start_time;
  if (form.end_time !== shift.end_time) body.end_time = form.end_time;
  return { body };
}

export function duplicateErrorMessage(err) {
  const d = err?.response?.data?.detail;
  const map = {
    ITEMS_NEED_SAME_LENGTH: 'This shift has several service items — keep the same length (move start and end together), then adjust the items after copying.',
    NO_ACTIVE_AGREEMENT: 'No ACTIVE service agreement covers this participant on that date.',
    RATIO_2TO1_STAFF_REQUIRED: 'A 2:1 SIL shift needs both workers when created — create it from the house view.',
  };
  return map[d?.code] || d?.message || (typeof d === 'string' ? d : null) || err?.response?.data?.error?.message || 'Could not duplicate the shift';
}
